export default __webpack_public_path__ + "static/media/forbes_grey.389e4a0f.webp";